import { jsx as _jsx } from "react/jsx-runtime";
import ProfileSections from "./components/sections/ProfileSections";
import { defaultProfile } from "./constants/profile";
import { isProfileValid } from "./utils/utils";
const ProfileForm = ({ profile, config }) => {
    return (_jsx("div", { "data-component": "idk-profile-form", "data-component-group": "idk", children: _jsx(ProfileSections, { profile: isProfileValid(profile)
                ? profile
                : defaultProfile, config: config }) }));
};
export default ProfileForm;
//# sourceMappingURL=ProfileForm.js.map